import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import MaskedTextInput from '../MaskedTextInput';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import t from '@instructure/quiz-i18n/format-message';
export var AccessCodeTextInput = /*#__PURE__*/function (_Component) {
  function AccessCodeTextInput() {
    var _this2;
    _classCallCheck(this, AccessCodeTextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AccessCodeTextInput, [].concat(args));
    _defineProperty(_this2, "state", {
      masked: true
    });
    _defineProperty(_this2, "handleMaskedChange", function () {
      _this2.setState(function (state) {
        return {
          masked: !state.masked
        };
      });
    });
    return _this2;
  }
  _inherits(AccessCodeTextInput, _Component);
  return _createClass(AccessCodeTextInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(MaskedTextInput, Object.assign({
        renderLabel: /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Access Code')),
        display: "inline-block",
        type: "text",
        onMaskedChange: this.handleMaskedChange,
        masked: this.state.masked,
        checkboxLabel: t('Show access code')
      }, this.props));
    }
  }]);
}(Component);
export default AccessCodeTextInput;